import OrderExtraPart from './OrderExtraPart';
import { withI18n } from 'react-i18next';

export default withI18n()(OrderExtraPart);
